export default import.meta.ROLLUP_FILE_URL_A_FmzD1u9ybwAYzEW_WmHg